import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import getContract from '../services/contract';
import { ethers } from "ethers";
import { FaTelegramPlane } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import Modal from './modal'; // importing the Modal component

import useCss from "../helpers/useCss";
const materialize = "/home/css/materialize.css";
const bootstrap = "/home/css/bootstrap.css";
const styleCss = "/css/style.css";

const Home = () => {
  useCss('stylesheet', materialize);
  useCss('stylesheet', bootstrap);
  // useCss('stylesheet', styleCss);

  let [totalValue, setTotalValue] = useState(0);
  let [totalMembers, setTotalMembers] = useState(0);


  useEffect(() => {
    async function getData() {
      try {
        const contract = await getContract();
        setTotalMembers(ethers.BigNumber.from(await contract.lastIDCount()).toNumber());

        const valueInvestedBN = await contract.totalValueInvested();
        const totalInvested = +parseFloat(ethers.utils.formatUnits(valueInvestedBN, "ether")).toFixed(6);        
        setTotalValue(totalInvested);
      } catch (error) {
        console.log(error);
        // alert('Switch Network to Polygon chain');
      }
    }
    getData();
  }, []);

  return (
    <>
      <div className="wrapper" id="top">
        <header className="header" style={{ padding: "0px" }}>
          <div className="header-wrap"></div>
        </header>
        <div 
          // style={{ background: "url('/logo/bg-b.jpg')"}} 
          style={{ backgroundColor: "#000000"}}
          className="midd-container">
          <div
            className="hero-main platinum-layout white-sec"
            style={{ backgroundColor: "#262626" }}
            // style={{ background: "url('/logo/bg-b.jpg')"}}
          >
            <div className="container">
              <div className="row align-items-center">
                
                <div className="col-sm-12 col-md-12 mobile-center text-center">
                  <div className="image-container flex justify-center mb-2">
                    <img style={{width: "400px"}} src="/logo/Logo.png" className="" />
                  </div>
                  {/* <div className="w-20">
                    <span className="d-inline">
                      <img src="/logo/MATIC.png" width="100%" className="logo d-inline" />
                      <h2 className="d-inline">Brilliant X Chain</h2>
                    </span>
                  </div> */}
                  <h1 style={{ fontWeight: "bolder", fontSize: "40px" }}>
                   <span style={{ color: "#ffc107" }}>Infinite 1x2 Matrix</span>{" "}
                    <span>On Binance Smart Chain</span>
                  </h1>
                  
                  <div
                    className="hero-btns heading-content__btns flex justify-center text-center"
                    style={{ paddingTop: "35px" }}
                  >
                    <div className="btn-wrap text-center">
                      <a
                        href="/join"
                        className="def-btn m text-center def-blue login__button"
                        style={{
                          whiteSpace: "nowrap",
                          background: "#C49E0D",
                          // display: "inline-block",
                          // minWidth: "300px",
                          height: "80px",
                          fontSize: "30px"
                          // lineHeight: "50px",
                        }}
                      >
                        Join
                      </a>
                    </div>
                    <div className="btn-wrap text-center">
                      <a
                        href="/login"
                        className="def-btn text-center def-blue login__button"
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          background: "#C49E0D",
                          // display: "inline-block",
                          // minWidth: "300px",
                          height: "80px",
                          fontSize: "30px",
                          // color: "white"
                          // lineHeight: "50px",
                        }}
                      >
                        SIGN IN{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="advantages-number" style={{ zIndex: 99, backgroundColor: "#000000" }}>
            <div className="advantages-number-wrap total-stat flex" id="total-stat">
              <div className="advantages-number__item revealator-zoomin revealator-once revealator-within">
                <div className="advantages-number__item-title">Total<br />Members</div>
                <div className="advantages-number__item-content">
                  <nobr>{totalMembers}</nobr>
                </div>
              </div>
              
              <div className="advantages-number__item revealator-zoomin revealator-once revealator-within">
                <div className="advantages-number__item-title">Total<br/>Earn (BTCB)</div>
                <div className="advantages-number__item-content">
                  <nobr>{totalValue} </nobr> 
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <div className="" style={{
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              backgroundImage: "url('/logo/bg8.jpg')",
              width: "100%",
              borderTop: "8px solid #fbbd18",
            }}>
              <div className="container mt-5">
                <div className="flex justify-center items-center text-center mb-4">
                  <div className="advantages-number__item-content">
                    <nobr style={{ fontSize: "40px" }} className="">How it works</nobr>
                  </div>
                </div>
                <div className="row">

                  <div className="col-md-12">
                    <div
                      className="panel-group"
                      id="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree10"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree10"
                              aria-expanded="false"
                              aria-controls="collapseThree10"
                            >
                              WHAT IS DECENTRALIZATION?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree10"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree10"
                        >
                          <div className="panel-body">
                            <p>
                              The process works based on distributing authority
                              from a centralized administration to the
                              participants involved in the process. Unlike a
                              centralized system, all decisions are made by
                              consensus.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree5"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree5"
                              aria-expanded="false"
                              aria-controls="collapseThree5"
                            >
                              WHICH WALLET SHOULD I USE?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree5"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree5"
                        >
                          <div className="panel-body">
                            <p>
                              Bitcoin Spaceship (BTS) works with all crypto wallets. When working
                              with BTS : - for all types of EVM wallets like
                              Metamask, Trust Wallet, Token Pocket (TP) and/or etc. These wallets are among
                              the most popular and demanded in the global crypto industry.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingOne"
                        >
                          <h4 className="panel-title">
                            <a
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree12"
                              aria-expanded="true"
                              aria-controls="collapseThree12"
                            >
                              WHAT IS INFINITY MATRIX?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree12"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="collapseThree12"
                        >
                          <div className="panel-body">
                            <p>
                              BTS is 1x2 infinite levels Matrix which is developed on Binance Smart Chain (BSC).
                              it has upto 9 BTS upgrades of <span style={{ color: "#fff707ff" }}>0.00015, 0.00035, 0.0012, 0.0035, 0.01, 0.03, 0.07, 0.17, 0.35 BTCB</span> respectively and has no recycle OR re-join. <br />
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree21"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree21"
                              aria-expanded="false"
                              aria-controls="collapseThree21"
                            >
                              WHAT ARE "OVERFLOWS" AND "OVERTAKES"?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree21"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree21"
                        >
                          <div className="panel-body">
                            <p>
                              Overflows are when vacant places in your sites are
                              filled with partners who were not invited by you.
                              They can come from both an upstream partner and a
                              downstream partner. <br />
                              Overtaking is a situation when
                              your partner does not have a Rank that his
                              partner activates and the transaction is sent
                              along the chain to you, provided that you have
                              this Rank active. This partner follows you and
                              brings you income until his superior partner
                              activates the missing Rank.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingTwo"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              BTS PAYOUT SYSTEM
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseTwo"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingTwo"
                        >
                          <div className="panel-body">
                            <p>
                              Matrix Levels Payouts for each BTSs are as below: <br />
                              <span style={{ color: "rgba(255, 251, 7, 1)" }}> - Sponser pay (10%) <br /> - 10 Uplines Matrix Level (50%) - 4 VIP Pools Reward (10%)<br /></span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree5"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree11"
                              aria-expanded="false"
                              aria-controls="collapseThree11"
                            >
                            <span style={{ color: "rgba(255, 251, 7, 1)" }}> WHAT IS VIP REWARDS? </span>
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree11"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree11"
                        >
                          <div className="panel-body">
                            <p>
                             VIP Rewards have 4 pools, VIP#1-4 for any wallets that upgrade to BTS#5-9, BTS#6 (Be on VIP#1).., BTS#9 (Be on VIP#4), 10% from payout system will be collect and divided for all qualified wallets equally in each pools.
                            </p>
                          </div>
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clear"></div>
        <footer style={{zIndex: "1000" }} className="diamond-footer">
          <div className="footer-widget-area">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-md-4 widget-area logo_clear_first">
                  <div
                    className="widget widget-html"
                    style={{ paddingTop: "30px" }}
                  >
                    {/* <div className="footer-logo">
                      <img
                        src="/logo/BX.png"
                        style={{ width: '100px', paddingBottom: "30px", marginTop: "-20px" }}
                      />
                      <span style={{ fontSize: "15px" }}>
                        Copyright © 2023. All Rights Reserved
                      </span>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-6 col-md-4 widget-area">
                  <div className="widget widget-html text-center">
                    <h2 className="widget-title">Social Channel</h2>
                    <div className="socials">
                      <ul>
                        {/* <li>
                          <a target="_blank" href="https://www.facebook.com/sxm2023">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://twitter.com/sxm2023">
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li> */}
                        <li>
                       <a href="https://t.me/btcsp2025" target="_blank" rel="noopener noreferrer">
                          <FaTelegramPlane className="telegram-icon" />
                       </a>
                        
                          {/* <a target="_blank" rel="noopener noreferrer" href="https://t.me/btcsp2025">
                            <FaTelegramPlane />
                          </a>  */}
                        </li>

                        {/* <li>
                          <a target="_blank" href="https://www.youtube.com/@sxm2023">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li> */}

                      </ul>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;


// useScript(jqueryScript);
  // useScript(carausalScript);
  // useScript(jqueryFancyScript, true);
  // useScript(revealatorJs, true);
  // useScript(circleProgress);
  // useScript(bootstrapScript);
  // useScript(onPageScroll);
  // useScript(wow);
  // useScript(jqueryCountdown);
  // useScript(owlScript);
  // useScript(slickScript);
  // useScript(particles);
